<template>
  <div class="page--pimple-pop game bbb-pages">
    <img src="/static/img/laka-event/frame-laka.png" class="cosrx-header-img" />
    <div class="header">
      <div class="wrapper">
        <div class="progress-wrapper">
          <div class="progress">
            <div class="progress-bar" :style="{ width: `${game.state.persenProgress}%` }"></div>
          </div>
        </div>
      </div>
      <span class="header__timer">00:{{ game.time }}</span>
    </div>

    <div class="game-arena">
      <div class="score">
        <span v-if="isVnSource" class="score__text">ĐIỂM</span>
        <span v-else class="score__text">SCORE</span>
        <span class="score__point">{{ game.zit }}</span>
      </div>

      <div class="game-arena__actor">
        <div class="game-arena__grid">
          <!-- <div class="col-pimple" :class="{[key]: true}" v-for="(item, key) in game.area">
						<a href="" class="actor"
							:class="{
								'unused-col': !item.isShow,
								[game.area[key].actor]: item.isShow}"
							@click.prevent="getActor($event,{index: key, actor: game.area[key].actor, show: item.isShow, point: item.point})"
						>
						</a>
						<transition name="pointfade">
							<span class="pimple-point" v-show="item.zitShow"></span>
						</transition>
					</div> -->

          <div v-for="(item, key) in game.area" :key="key" class="col-pimple" :class="{ [key]: true }">
            <a
              v-show="item.isShow"
              href=""
              class="actor"
              :class="[game.area[key].actor]"
              @contextmenu.prevent
              @click.prevent="
                getActor($event, { index: key, actor: game.area[key].actor, show: item.isShow, point: item.point })
              "
            >
              <img :src="image(game.area[key].actor)" style="max-height: 250px" />
            </a>
            <transition name="pointfade">
              <span v-show="item.zitShow" class="pimple-point"></span>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div v-show="game.state.isReadyToPlay === false" class="overlay">
      <span class="text">{{ game.countdown }}</span>
    </div>
    <audio
      v-if="game.countdown == 'GO!'"
      src="https://s3-ap-southeast-1.amazonaws.com/images.soco.id/big-bang-boom/Big-Bang-Boom_BGM.ogg"
      preload="auto"
      autoplay
    ></audio>
  </div>
</template>

<script>
import config from '@/shared/pimple-pop/configBigBangBoom';
import VendingMachineTracker from '@/mixins/vending-machine-tracker';
import connectionHelper from '@/mixins/connection-helper.js';
import productLaka3 from 'static/img/laka-event/product-laka-3.png';
import productLaka2 from 'static/img/laka-event/product-laka-2.png';
import productLaka1 from 'static/img/laka-event/product-laka-1.png';
import photoFruit1 from 'static/img/laka-event/photo-fruit-1.png';
import photoFruit2 from 'static/img/laka-event/photo-fruit-2.png';

const Random = require('random-js');
const random = new Random(Random.engines.mt19937().autoSeed());
const moment = require('moment');
let timerState;

export default {
  name: 'PimplePopGame',
  mixins: [VendingMachineTracker, connectionHelper],
  data() {
    return {
      game: {
        actor: {
          'actor--laka3': {
            value: 3,
          },
          'actor--laka2': {
            value: 2,
          },
          'actor--laka1': {
            value: 1,
          },
          'actor--fruit1': {
            value: -2,
          },
          'actor--mystery': {
            value: {
              plus: 10,
              minus: -15,
            },
          },
        },
        addPimple: this.addPimple,
        area: [],
        areaNumber: 9,
        code: {
          A: {
            name: 'actor--laka3',
          },
          B: {
            name: 'actor--laka2',
          },
          C: {
            name: 'actor--laka1',
          },
          D: {
            name: 'actor--fruit1',
          },
          F: {
            name: 'actor--mystery',
          },
        },
        countdown: 3,
        listNotAllowedAreaPimple: [],
        pimpleArea: [],
        randomArea: this.randomArea,
        readyPlay: this.readyPlay,
        removeAllPimple: this.removeAllPimple,
        removePimple: this.removePimple,
        resultsRandomArea: [],
        runTimer: this.runTimer,
        zit: 0,
        randomConfig: 0,
        start: this.start,
        state: {
          isReadyToPlay: false,
          persenProgress: 0,
          currentIndex: 0,
          patternIndex: null,
          mystery: null,
          arrIndexMystery: 0,
        },
        time: 15,
        playingTime: 15,
      },
    };
  },
  computed: {
    patterns() {
      return config[this.randomConfig];
    },
    isVnSource() {
      return this.$route.query.isvn;
    },
  },
  watch: {
    'game.state.isReadyToPlay'(newVal) {
      if (newVal) {
        this.start(); // TODO: remove comment after testing
        this.runTimer(); // TODO: remove comment after testing
      }
    },
  },
  beforeDestroy() {
    clearInterval(timerState);
    this.destroyListener();
  },
  mounted() {
    this.readyPlay();
  },
  created() {
    this.randomConfig = random.integer(0, 2);
    this.buildGameState();
    this.$store.commit('setStartTime', moment().toISOString());

    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },
  methods: {
    image(item) {
      if (item == 'actor--laka3') {
        return productLaka3;
      }
      if (item == 'actor--laka2') {
        return productLaka2;
      }
      if (item == 'actor--laka1') {
        return productLaka1;
      }
      if (item == 'actor--fruit1') {
        return Math.random() < 0.5 ? photoFruit1 : photoFruit2;
      }
    },
    addPimple() {
      const stateAddPimple = setInterval(() => {
        const randArea = this.game.randomArea();
        let actorPattern;

        if (this.game.time == '00') {
          clearInterval(stateAddPimple);
          this.game.removeAllPimple();
        }

        if (this.game.time != '00' && randArea) {
          for (let i = 0; i < randArea.length; i++) {
            actorPattern = this.patterns.start[this.game.state.currentIndex]
              ? this.patterns.start[this.game.state.currentIndex].actor[i]
              : false;
            this.game.area[randArea[i]].isShow = true;
            this.game.area[randArea[i]].clickCount = 0;
            this.game.area[randArea[i]].actor = actorPattern ? this.game.code[actorPattern].name : '';

            if (this.game.code[actorPattern] && this.game.code[actorPattern].name === 'actor--mystery') {
              this.game.area[randArea[i]].point = this.patterns.start[this.game.state.currentIndex].mystery_value;
            }

            if (this.game.pimpleArea.length > 17) {
              this.game.pimpleArea[this.game.pimpleArea.length - i] = randArea[i];
            } else {
              this.game.pimpleArea.push(randArea[i]);
            }
          }
        }

        this.game.state.currentIndex++;
      }, 1000);
    },
    buildGameState() {
      // set area
      for (let i = 0; i < this.game.areaNumber; i++) {
        if (this.$SO.inArray(i, this.game.listNotAllowedAreaPimple) > -1) {
          this.$set(this.game.area, i, { isShow: false, actor: null, isAllowed: false, zitShow: false, clickCount: 0 });
        } else {
          this.$set(this.game.area, i, { isShow: false, actor: null, isAllowed: true, zitShow: false, clickCount: 0 });
        }
      }
    },
    getActor(e, { index, actor, show, point }) {
      if (show && e.isTrusted) {
        this.game.area[index].clickCount = this.game.area[index].clickCount + 1;
        let zit = 0;
        if (actor === 'actor--mystery') {
          zit = this.game.actor['actor--mystery'].value[point];
        } else {
          zit = this.game.actor[actor].value;
        }

        if (actor === 'actor--red' && this.game.area[index].clickCount < 3) {
          // zit = 0
        }

        if (!isNaN(zit)) {
          this.game.zit += zit;
          // this.$store.dispatch('adjustZitPerGameJerawat', zit)
          // this.$store.dispatch('adjustZitJerawat', zit)

          if (
            (actor === 'actor--laka3' && this.game.area[index].clickCount > 0) ||
            (actor === 'actor--laka2' && this.game.area[index].clickCount > 0) ||
            (actor === 'actor--laka1' && this.game.area[index].clickCount > 0) ||
            (actor === 'actor--mystery' && this.game.area[index].clickCount > 0) ||
            (actor === 'actor--fruit1' && this.game.area[index].clickCount > 0) ||
            (actor === 'actor--fruit2' && this.game.area[index].clickCount > 0)
          ) {
            this.game.area[index].isShow = false;
            this.game.area[index].actor = null;
            this.game.area[index].zitShow = true;
            if (zit !== 0) {
              e.target.parentElement.nextElementSibling.innerHTML = zit > 0 ? '+' + zit : zit;
              setTimeout(() => {
                this.game.area[index].zitShow = false;
              }, 10);
            }
          }
        }
      }
    },
    randomArea() {
      // use recursive concept
      // if doesnt meet empty area this function always call itselt until find a empty area
      let results;

      if (this.game.resultsRandomArea.length >= 3) {
        try {
          this.game.resultsRandomArea = [];
        } catch (err) {}
      }

      const randomNum = random.integer(0, 8);

      if (this.game.pimpleArea.length > 9) {
        if (this.game.area[randomNum].isAllowed) {
          if (this.$SO.size(this.game.resultsRandomArea) < 4) {
            this.game.area[randomNum].isShow = true;
            this.game.resultsRandomArea.push(randomNum);
            if (this.game.resultsRandomArea.length === 3) {
              results = Array.prototype.slice.call(this.game.resultsRandomArea);
              return results;
            } else {
              return this.randomArea();
            }
          }
        } else {
          return this.randomArea();
        }
      } else {
        if (this.game.area[randomNum].isShow || !this.game.area[randomNum].isAllowed) {
          try {
            return this.randomArea();
          } catch (err) {}
        } else {
          if (this.$SO.size(this.game.resultsRandomArea) < 4) {
            this.game.area[randomNum].isShow = true;
            this.game.resultsRandomArea.push(randomNum);
            if (this.game.resultsRandomArea.length === 3) {
              results = Array.prototype.slice.call(this.game.resultsRandomArea);
              return results;
            } else {
              return this.randomArea();
            }
          }
        }
      }
    },
    readyPlay() {
      this.$set(this.game, 'time', this.game.playingTime);
      const readyState = setInterval(() => {
        if (this.$SO.type(this.game.countdown) === 'number') {
          this.game.countdown--;
        }

        if (this.$SO.type(this.game.countdown) === 'string') {
          this.game.state.isReadyToPlay = true;
          clearInterval(readyState);
        }

        if (this.game.countdown === 0) {
          this.game.countdown = 'GO!';
        }
      }, 1000);
    },
    removePimple() {
      // FIFO flow
      const stateRemovePimple = setInterval(() => {
        let pimple;
        const pimpleArea = Array.prototype.slice.call(this.game.pimpleArea, 0, 3);
        for (let i = 0; i < pimpleArea.length; i++) {
          pimple = this.game.area[pimpleArea[i]];
          if (pimple.isShow) {
            pimple.isShow = false;
            pimple.actor = null;
            pimple.clickCount = 0;
            this.game.pimpleArea.shift(); // FIFO
          }
        }

        if (this.game.time == '00') {
          clearInterval(stateRemovePimple);
          this.game.removeAllPimple();
        }
      }, 2000);
    },
    removeAllPimple() {
      for (let i = 0; i < this.game.area.length; i++) {
        this.game.area[i].isShow = false;
        this.game.area[i].actor = null;
      }
    },
    runTimer() {
      timerState = setInterval(() => {
        this.game.state.persenProgress += 100 / this.game.playingTime;
        this.game.time--;
        if (this.$SO.type(this.game.time) === 'number' && this.game.time < 10) {
          this.game.time = '0' + this.game.time;
        }
        // the finish state of the game
        if (this.game.time == '00') {
          clearInterval(timerState);
          // this.$store.commit("setZits", 100)
          this.$store.commit('setZits', this.game.zit);
          if (this.isVnSource) {
            this.$router.push({ path: '/vending-machine-vn/pimple-pop/finish', query: { isvn: 'true' } });
          } else {
            this.$router.push('/laka-vending-machine-event/bbb-game-finish');
          }
        }
      }, 1000);
    },
    start() {
      const randArea = this.game.randomArea();
      for (let i = 0; i < randArea.length; i++) {
        this.game.area[randArea[i]].actor = this.game.code[this.patterns.ready.actor[i]].name;
        if (this.game.code[this.patterns.ready.actor[i]].name === 'actor--mystery') {
          this.game.area[randArea[i]].point = this.patterns.ready.mystery_value;
        }
        this.game.pimpleArea.push(randArea[i]);
      }

      this.game.addPimple();
      this.game.removePimple();
    },
    async forceQuit() {
      // this.postTracker('play_close');
      clearInterval(timerState);
      this.$store.commit('setZits', 0);
      this.$router.push('/laka-vending-machine-event/home');
    },
  },
};
</script>

<style lang="scss" scoped>
.go-image {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  animation: goImagePulse 0.5s ease-in-out;
  z-index: 1000;
}
.cosrx-header-img {
  width: 100%;
}

.bbb-pages {
  height: 1920px;
  overflow: hidden;
  .header {
    background: #5e0223;
    padding: 15px 0;
    display: flex;
    height: 130px;
    .wrapper {
      width: 85%;
    }
  }
  .score {
    background: #58002a;
    border-radius: 15px;
    font-family: 'Pretendard';
    height: 156px;
    gap: 12px;
  }
  .progress-wrapper {
    background: transparent;
  }
  .progress-bar {
    background: #d59e75;
  }
  .header__timer {
    font-family: 'Pretendard';
  }
  .score__point,
  .score__text {
    font-family: 'Pretendard';
  }
  .game-arena {
    background: #000 url('/static/img/laka-event/laka-game-bg.png') no-repeat center -226px;
    background-size: 100% auto;
  }
  .game-arena__actor {
    background: none;
  }

  .actor {
    display: block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    opacity: 0;
    transition: opacity 0.3s ease;
    display: block;
    user-select: none;
    img {
      width: 100%;
      height: 100%;
      object-fit: content;
      user-select: none;
    }
  }

  .game-arena__grid {
    width: 980px;
    height: 980px;
    margin: 220px auto 0;
  }

  .actor--laka3 {
    opacity: 1;
    width: 59%;
    height: 59%;
  }
  .actor--laka2 {
    opacity: 1;
    width: 59%;
    height: 59%;
  }
  .actor--laka1 {
    opacity: 1;
    width: 59%;
    height: 59%;
  }
  .actor--fruit1 {
    opacity: 1;
    width: 59%;
    height: 59%;
  }
  .actor--fruit2 {
    opacity: 1;
    width: 59%;
    height: 59%;
  }

  .pimple-point {
    position: absolute;
    z-index: 1;
    top: 0;
    left: calc(50% - 30px);
    color: #5e0223;
    font-family: 'Pretendard', sans-serif;
    font-size: 72px;
    line-height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .pointfade-enter-active,
  .pointfade-leave-active {
    transition: all 1s;
  }

  .pointfade-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .col-pimple {
    width: calc(100% / 3) !important;
    height: calc(100% / 3) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    user-select: none;
  }
}
@media screen and (max-width: 950px) and (min-width: 900px) {
  .bbb-pages {
    .game-arena__grid {
      width: 880px;
      height: 880px;
      margin: 174px auto 0;
    }
  }
  .page--pimple-pop.game .game-arena__actor {
    width: 934px;
  }
}
</style>
